<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Moderar Requisição de Acesso</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Nome do Requisitante</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        readonly
                                        :value="requestAccess.person_name"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Nome da Empresa</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        readonly
                                        :value="requestAccess.company_name"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Telefone</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        readonly
                                        :value="requestAccess.phone"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>E-mail</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        readonly
                                        :value="requestAccess.email"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5" v-if="requestAccess.moderate === null">
                            <div class="offset-md-3 col-md-3">
                                <button
                                    class="btn btn-return btn-block"
                                    @click="moderate(0)"
                                >Recusar</button>
                            </div>
                            <div class="col-md-3">
                                <button
                                    class="btn btn-normal btn-block"
                                    @click="moderate(1)"
                                >Aceitar</button>
                            </div>
                        </div>
                        <div class="pull-right">
                            <router-link :to="'/requestAccess'" class="btn btn-normal">
                                <i class="fa fa-arrow-left"></i> Voltar
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            requestAccess: {
                company_name: "",
                person_name: "",
                email: "",
                phone: ""
            }
        };
    },
    methods: {
        getRequestAccess: function() {
            const self = this;
            const api =
                self.$store.state.api +
                "requestaccess/" +
                self.$route.params.id;
            self.$http
                .get(api)
                .then(response => {
                    self.requestAccess = response.data.data[0];
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        moderate(moderate) {
            const self = this;
            const api = self.$store.state.api + "requestaccess/moderate";
            self.$http
                .post(api, {
                    id: self.$route.params.id,
                    moderate: moderate
                })
                .then(response => {
                    self.$message(
                        "Sucesso",
                        moderate
                            ? "Requisição de acesso aceita"
                            : "Requisição de acesso negada",
                        "success"
                    );
                    self.$router.push("/requestAccess");
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        }
    },
    mounted: function() {
        this.getRequestAccess();
    }
};
</script>


// WEBPACK FOOTER //
// src/components/RequestAccess/RequestAccess.vue